import dynamic from "next/dynamic";
import { Box } from "@mui/material";
import style from "react-syntax-highlighter/dist/esm/styles/prism/okaidia";

const SyntaxHighlighter = dynamic(() =>
  import("react-syntax-highlighter").then(module => module.Prism)
);
const Markdown = dynamic(() => import("react-markdown"));

export const RenderMarkdownCode = ({ md }) => (
  <Markdown components={{ code: Code }}>{md}</Markdown>
);
export default function Code({ children: code, className, node, ...rest }) {
  const language = className?.split("language-")[1];

  return language ? (
    <Box
      sx={{
        minHeight: 56,
        position: "relative",
        border: 1,
        borderRadius: "var(--shape-md-round)",
        borderColor: "var(--dark-outline-variant)",
        bgcolor: "var(--dark-surface-dim)",
        color: "var(--dark-surface-on)",
        "& > pre": {
          m: "0 !important",
          pl: "12px !important",
          typography: "code",
          overflow: "hidden",
          bgcolor: "var(--dark-surface-dim) !important",
          borderRadius: "var(--shape-md-round) !important",
          "& code": {
            typography: "code",
            overflow: "hidden",
            whiteSpace: "break-spaces !important" // Key: Break long words
          }
        },
        "& *": {
          typography: "code",
          borderBottomLeftRadius: "inherit",
          borderBottomRightRadius: "inherit",
          fontSize: { compact: 11, expanded: 12 }
        }
      }}
    >
      <SyntaxHighlighter language={language} style={style}>
        {code?.trim()}
      </SyntaxHighlighter>
    </Box>
  ) : (
    <code {...rest} className={className}>
      {code}
    </code>
  );
}
